import {FC, ReactNode, RefObject} from 'react'

import {useServiceCommonContent} from '@/content/service-request/common'
import {useTranslation} from '@/i18n'
import {
  CONTAINER_PADDING_MOBILE,
  CONTAINER_WIDTH,
  HEADER_HEIGHT_DESKTOP,
  SECTION_PADDING_DESKTOP,
  SECTION_PADDING_MOBILE,
} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {Text, TextVariant} from '../common/content/Text'

type ServiceRequestLayoutProps = {
  content: ReactNode
  form: ReactNode
  formRef?: RefObject<HTMLDivElement>
}

export const ServiceRequestLayout: FC<React.PropsWithChildren<ServiceRequestLayoutProps>> = ({
  content,
  form,
  formRef,
}) => {
  const {t} = useTranslation()
  const {title} = useServiceCommonContent().form

  return (
    <>
      <div className="wrapper">
        <div className="content">{content}</div>
        <aside ref={formRef} className="sidebar">
          <div data-test="ServiceRequestLayout-formTitle" className="title">
            <Text variant={TextVariant.h2} align="center">
              {t(title)}
            </Text>
          </div>
          <div className="form">{form}</div>
        </aside>
      </div>

      <style jsx>{`
        .wrapper {
          display: flex;
        }
        .content {
          flex: 1;
          max-width: calc((${CONTAINER_WIDTH} - ${theme.spacing[8]}) / 2);
        }
        .sidebar {
          flex: 1;
          position: sticky;
          top: calc(${HEADER_HEIGHT_DESKTOP} + ${theme.spacing[5]});
          height: 100%;
          margin-left: ${theme.spacing[8]};
        }
        .title {
          display: none;
        }
        .form {
          padding: ${theme.spacing[5]};
          border-radius: 8px;
          background-color: ${theme.palette.background.butter};
        }
        @media ${TABLET_SCREENSIZE} {
          .wrapper {
            display: block;
          }
          .content {
            max-width: inherit;
          }
          .sidebar {
            position: relative;
            top: 0;
            max-width: 500px;
            margin-top: ${SECTION_PADDING_DESKTOP};
            margin-left: auto;
            margin-right: auto;
          }
          .title {
            display: block;
            margin-bottom: ${theme.spacing[6]};
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .sidebar {
            margin-top: ${SECTION_PADDING_MOBILE};
          }
          .title {
            margin-bottom: ${theme.spacing[5]};
          }
          .form {
            padding: ${theme.spacing[5]} ${CONTAINER_PADDING_MOBILE};
          }
        }
      `}</style>
    </>
  )
}
